import {
    SignupExternalLegalEntity,
    SignupExternalPartnership,
    SignupExternalPersonal,
} from '../../../data-layer/partner/types';

export enum PartnerRegistrationSteps {
    Register = 'register',
    Approve = 'approve',
    BankData = 'bankData',
    SignerData = 'signerData',
    Done = 'done',
}

export const STEP_MAPPING: Record<string, PartnerRegistrationSteps> = {
    type: PartnerRegistrationSteps.Register,
    bank: PartnerRegistrationSteps.BankData,
    signer: PartnerRegistrationSteps.SignerData,
    submit: PartnerRegistrationSteps.Done,
    complete: PartnerRegistrationSteps.Done,
};

export type ApiError = { message: string };

export interface ErrorField {
    field:
        | keyof SignupExternalPersonal
        | keyof SignupExternalLegalEntity
        | keyof SignupExternalPartnership;
    description: string | null;
    message: string[] | null;
    nested_errors?: ErrorField[][];
}

export interface ApiErrorResponse {
    result: string;
    data?: string | ErrorField[];
    content?: string;
}

export interface AxiosError {
    response?: {
        data?: ApiErrorResponse;
    };
}
